import type { CSSProperties } from "react";

const paths = {
  onboarding:
    "M8 3h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z M10 17h4 M9 8l3 3 3-3",
  paywall: "M4 6h16v13H4z M4 10h16 M7 15h3 M8 3h8",
  flags: "M5 21V4 M5 4c5-4 9 4 14 0v10c-5 4-9-4-14 0",
  revisions: "M3 11a9 9 0 1 1 2 7 M3 4v7h7 M12 7v5l3 2",
  products: "m12 3 9 5-9 5-9-5 9-5Z M3 8v9l9 5 9-5V8 M12 13v9 M7 5l9 5",
  funnels: "M3 4h18l-7 8v7l-4 2v-9L3 4Z",
  experiments: "M9 3h6 M10 3v6L4 19a1 1 0 0 0 1 2h14a1 1 0 0 0 1-2L14 9V3 M8 14h8",
  sessions: "M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6l-8-3Z m-4 9 3 3 5-6",
  looks: "M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h6v6h-6z",
  templates: "M4 3h16v18H4z M4 9h16 M10 9v12",
  menu: "M4 6h16 M4 12h16 M4 18h16",
  close: "m6 6 12 12 M18 6 6 18",
  arrow: "M5 12h14 m-5-5 5 5-5 5",
  logout: "M9 4H4v16h5 M10 12h11 m-4-4 4 4-4 4",
} as const;
export type IconName = keyof typeof paths;
export function Icon({
  name,
  size = 20,
  style,
}: {
  name: IconName;
  size?: number;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={style}
    >
      <path d={paths[name]} />
    </svg>
  );
}
